<terra-dialog-header [showCloseButton]="data.showCloseIcon">
  @if(data.icon) {
    <mat-icon class="icon" [ngClass]="data.iconClass">
      {{data.icon}}
    </mat-icon>
  }
  <h1 [innerHTML]="data.title"></h1>
</terra-dialog-header>

<mat-dialog-content>
  @if(!!data.description) {
    <div class="description" [innerHTML]="data.description"></div>
  }
  @if(!!data.highlightText) {
    <ng-container>
      <terra-information-hint [text]="data.highlightText" [backgroundColor]="data.highlightColor" />
    </ng-container>
  }
  <!-- <div class="highlight" *ngIf="!!data.highlightText">
    <mat-icon class="notranslate material-icons-outlined">info</mat-icon>
    <span [innerHTML]="data.highlightText | safeHtml"></span>
  </div> -->
  <ng-template terraAddDynamicComponent />
</mat-dialog-content>

<div mat-dialog-actions [ngClass]="data.actionPosition">
  @if(!data.hideCancel) {
    <button
      [mat-dialog-close]="false"
      type="button"
      mat-button
      aria-label="Close"
      class="cancel-button"> 
      {{ data.cancelLabel ? data.cancelLabel : "Cancel" }}
    </button>
  }
  @if(data.secondaryActionLabel) {
    <button
      class="secondary-action"
      mat-stroked-button
      color="basic"
      (click)="secondaryAction()">
      {{ data.secondaryActionLabel }}
    </button>
  }
  <button
    mat-flat-button
    color="{{ data.actionButtonColor }}"
    cdkFocusInitial
    class="action-button"
    (click)="action()"
    [disabled]="data.disableAction"
    [ngStyle]="{'background-color': data.actionButtonColorCode}" >
    {{ data.actionLabel ? data.actionLabel : "OK" }}
    @if(data.svgIcon) {
      <mat-icon svgIcon="{{ data.svgIcon }}" class="notranslate" />
    }
  </button>
</div>
